module.exports = __webpack_public_path__ + "media/categories/208-688be49b.svg";